import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import HeaderRec from '../../header/headerRec';
import SharePopup from '../../commun/SharePopup';
import MissionTabs from '../../commun/MissionTabs';
import MissionInfo from '../../commun/MissionInfo';
import ProfilRecherche from '../../commun/ProfilRecherche';
import InfosComplementaires from '../../commun/InfosComplementaires';
import ContactCard from '../../commun/ContactCard';
import InfoCard from '../../commun/InfoCard';
import TalentCard from '../../commun/TalentCard';
import ActionCandidater from '../../commun/ActionCandidater';
import '../../Entreprise/Detailsmission/Detailsmission.css';
import Chatbox from '../../commun/ChatBox';
import Footer from '../../commun/Footer'
import LoadingPopup from "../../commun/LoadingPopup";
import NotFound404 from '../../commun/NotFound404';

const DetailMission = () => {
  const recruteurName = localStorage.getItem("recruteurName");
  const authToken = localStorage.getItem("authToken");
  const userId = localStorage.getItem("userId");
  const { id } = useParams();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const [mission, setMission] = useState(null);
  const [editedMission, setEditedMission] = useState({});
  const [activeTab, setActiveTab] = useState('mission');
  const [selectedMission, setSelectedMission] = useState(null);
  const [favorites, setFavorites] = useState([]);
  const [candidatures, setCandidatures] = useState([]);
  const [entreprise, setEntreprise] = useState(null);

  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/missions/${id}`);
        if (!res.ok) throw new Error('Mission not found');

        const missionData = await res.json();
        setMission(missionData);
        setEditedMission(missionData);

        const entrepriseRes = await fetch(`${API_BASE}/api/entreprise/profil/${missionData.createdBy}`);
        if (entrepriseRes.ok) {
          const entrepriseData = await entrepriseRes.json();
          setEntreprise(entrepriseData);
        }

        const favRes = await fetch(`${API_BASE}/api/recruteur?userId=${userId}`, {
          headers: { Authorization: `Bearer ${authToken}` }
        });
        if (favRes.ok) {
          const favData = await favRes.json();
          setFavorites(favData.map(m => m._id));
        }

        const candRes = await fetch(`${API_BASE}/api/candidatures/missionR/${id}/${userId}`);
        if (candRes.ok) {
          const candData = await candRes.json();
          setCandidatures(candData);
        }

        setLoading(false);
      } catch (err) {
        console.error("Erreur de chargement:", err);
        setNotFound(true);
        setLoading(false);
      }
    };

    loadData();
  }, [id]);

  if (loading) return 
    <LoadingPopup
      open={!mission}
      message="Chargement..."
    />;
  if (notFound) return <NotFound404 />;

  const toggleFavorite = async (missionId) => {
    try {
      await axios.post(
        `${API_BASE}/api/recruteur/favorites/${missionId}?userId=${userId}`,
        {},
        { headers: { Authorization: `Bearer ${authToken}` } }
      );

      setFavorites(prev =>
        prev.includes(missionId)
          ? prev.filter(id => id !== missionId)
          : [...prev, missionId]
      );
    } catch (err) {
      console.error("Erreur lors du changement de favori :", err);
    }
  };

  return (
    <div className="entreprise-page">
      <HeaderRec recruteurName={recruteurName} authToken={authToken} userId={userId} />
      <main className="pageContainer">
  <div className="contentWrapper">
    <div className="contentGrid">
      
      {/* ✅ Colonne de gauche */}
      <aside className="leftColumn">
  <div className="contactCardContainer">
    <ContactCard mission={editedMission} editable={false} utilisateur={mission.utilisateur} />
    <div className="actionCandidaterWrapper">
      <ActionCandidater
        mission={mission}
        candidatures={candidatures}
        onClick={() => {
          navigate(`/recruteur/travailler-mission/${mission._id}`);
        }}
      />
    </div>
  </div>
          {/* ✅ Talents suggérés */}
        <TalentCard missionId="id_de_la_mission" />
</aside>


      {/* ✅ Colonne principale */}
      <section className="mainColumn">
        <div className="missionContent">
          <MissionTabs activeTab={activeTab} setActiveTab={setActiveTab} viewerType="recruteur" />

          {activeTab === 'mission' && (
            <MissionInfo
              mission={mission}
              editedMission={editedMission}
              editable={false}
              isRecruteurView={true}
              favorites={favorites}
              toggleFavorite={toggleFavorite}
              setSelectedMission={setSelectedMission}
              showActionButtons={false}
              entrepriseLogo={entreprise?.logo}
            />
          )}

          {activeTab === 'profil' && (
            <ProfilRecherche
              editedMission={editedMission}
              editable={false}
              showActionButtons={false}
              entrepriseLogo={entreprise?.logo}
              isRecruteurView = {true}
            />
          )}

          {activeTab === 'infos' && (
            <InfosComplementaires candidatures={candidatures} viewerType="recruteur" />
          )}
        </div>
      </section>

      {/* ✅ Colonne de droite */}
      <aside className="sideColumn">
       

        <InfoCard
  mission={editedMission}
  editable={false}
/>





      </aside>
    </div>
  </div>
</main>


      {selectedMission && (
        <SharePopup
          shareUrl={`${process.env.REACT_APP_FRONTEND_BASE_URL}/Recruteur/Details/${selectedMission._id}`}
          onClose={() => setSelectedMission(null)}
        />
      )}
            <Chatbox userRole="recruteur" />
                         <Footer />

    </div>

  );

};

export default DetailMission;
